const $ = require('jquery')
const q = new URLSearchParams(window.location.search)
const code = q.get('j') || ''
const decoded = atob(code) || false
const obj = JSON.parse(decoded) || false

document.body.innerHTML = document.body.innerHTML.replace(/{{nick}}/g, obj.nick);
if (obj.mode === '1x1') {
  document.getElementById('root-team').style.display = 'none';
}
if (obj.winning_value) {
  document.body.innerHTML = document.body.innerHTML.replace(/{{winning_value}}/g, 'R$ ' + obj.winning_value + '!');
} else {
  document.body.innerHTML = document.body.innerHTML.replace(/{{winning_value}}/g, 'grátis');
}

function getUrl() {
  if (!obj.room_id) {
    return 'clubedotruco://' + code;
  }
  var o = {
    room_id: obj.room_id,
    team: document.getElementById('team').value
  };
  var str = btoa(JSON.stringify(o));
  return 'clubedotruco://' + str;
}



$(function(){
  const noCode = $('#no-code')
  const withCode = $('#with-code')

  $('#close-dialog').on('click', function(event) {
    event.preventDefault()
    $('#dialog-error').hide()
  })

  if (obj) {
    withCode.removeClass('hidden')
  } else {
    noCode.removeClass('hidden')
  }


  $('#join').attr('href', getUrl())

})

